import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'tk-login-error',
	templateUrl: './login-error.component.html',
	styleUrls: ['./login-error.component.sass'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginErrorComponent {}
